import { createAsyncThunk } from "@reduxjs/toolkit";
import { DynamicOptionService } from "@core/services/dynamicOption.service.ts";
import { DynamicOptionPostDTO, DynamicOptionResponseDTO } from "@core/modeles/dynamicOption.model.ts";

const dynamicOptionService = new DynamicOptionService();

/**
 * Action Redux pour récupérer les options dynamiques standard d'une catégorie.
 * GET /dynamic-option/category/{category}
 */
export const fetchStandardDynamicOptions = createAsyncThunk<
  DynamicOptionResponseDTO[],
  string,
  { rejectValue: string }
>(
  "dynamicOption/fetchByCategory",
  async (category, { rejectWithValue }) => {
    try {
      const results = await dynamicOptionService.getByCategory(category);
      // console.log(
      //   `[DynamicOption] GET /dynamic-option/category/${category} → ${results.length} option(s)`
      // );
      // console.log(
      //   `[DynamicOption] 📦 Payload brut GET /${category}:`,
      //   JSON.stringify(results, null, 2)
      // );
      return results;
    } catch (error: any) {
      // console.error(`[DynamicOption] Erreur GET category/${category}:`, error);
      return rejectWithValue(error?.message ?? "Erreur inconnue");
    }
  }
);

/**
 * Action Redux pour créer une ou plusieurs options dynamiques.
 * Envoie 1 POST par item (le backend n'accepte qu'un objet par requête).
 */
export const createDynamicOptions = createAsyncThunk<
  DynamicOptionResponseDTO[],
  DynamicOptionPostDTO[],
  { rejectValue: string }
>(
  "dynamicOption/create",
  async (payload, { rejectWithValue }) => {
    try {
      // console.log(
      //   `[DynamicOption] 🚀 Envoi de ${payload.length} requête(s) POST /dynamic-option`
      // );
      const results: DynamicOptionResponseDTO[] = [];

      for (const item of payload) {
        // console.log(`[DynamicOption] POST /dynamic-option →`, JSON.stringify(item));
        const raw = await dynamicOptionService.createDynamicOption(item);
        // console.log(
        //   `[DynamicOption] 📦 Payload brut POST (raw):`,
        //   JSON.stringify(raw, null, 2)
        // );
        const response: DynamicOptionResponseDTO = Array.isArray(raw) ? raw[0] : raw as unknown as DynamicOptionResponseDTO;
        results.push(response);

        const remaining = Math.max(0, 3 - response.occurrenceCount);
        if (response.standard) {
          // console.log(
          //   `[DynamicOption] ✅ "${response.labelOriginal}" [${response.occurrenceCount}/3] → standard:true → VISIBLE dans la liste`
          // );
        } else {
          // console.log(
          //   `[DynamicOption] ⏳ "${response.labelOriginal}" [${response.occurrenceCount}/3] → standard:false → encore ${remaining} soumission(s) requise(s)`
          // );
        }
      }

      return results;
    } catch (error: any) {
      console.error("[DynamicOption] Erreur POST /dynamic-option:", error);
      return rejectWithValue(error?.message ?? "Erreur inconnue");
    }
  }
);
